
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[gameSlug]",
      function () {
        return require("private-next-pages/[gameSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[gameSlug]"])
      });
    }
  